import Footer from "app/pages/.shared/Footer/Footer";

import "./footer.scss";

export default props => <Footer {...props} />;
